import { render, staticRenderFns } from "./ApplicationBannersView.vue?vue&type=template&id=64735363&scoped=true"
import script from "./ApplicationBannersView.vue?vue&type=script&lang=ts"
export * from "./ApplicationBannersView.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationBannersView.vue?vue&type=style&index=0&id=64735363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64735363",
  null
  
)

export default component.exports